import { Pencil, Trash2 } from 'lucide-react';
import { Button } from '@/src/shadComponents/ui/button';
import useAuthenticatedApi from '../../Authentication/components/hooks/useAuthenticatedApi';

interface DeviceKeyActionsProps {
    orgId: number;
    row: any;
    onDelete: () => void;
    onRename: (deviceKey: DeviceKey) => void;
}

export default function DeviceKeyActions({
    orgId,
    row,
    onDelete,
    onRename,
}: DeviceKeyActionsProps) {
    const deviceKeyId = row.original.id;
    const authenticatedApi = useAuthenticatedApi();

    const performDelete = () => {
        const deleteRequest = async () => {
            const response = await authenticatedApi.delete(
                `${orgId}/device-keys/${deviceKeyId}`,
            );

            if (response.status === 200) {
                onDelete();
            }
        };

        const shouldDelete = window.confirm(
            `Are you sure you would like to delete ${row.original.name}`,
        );

        if (shouldDelete) {
            deleteRequest();
        }
    };

    const performRename = () => {
        onRename(row.original);
    };

    return (
        <div className="flex items-center gap-2">
            <Button variant="ghost" size="icon" onClick={performRename}>
                <Pencil className="size-4" />
            </Button>
            <Button variant="ghost" size="icon" onClick={performDelete}>
                <Trash2 className="size-4 text-destructive" />
            </Button>
        </div>
    );
}
